import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DataserviceService } from 'src/app/dataservice.service';

@Component({
  selector: 'app-dish-account-import',
  templateUrl: './dish-account-import.component.html',
  styleUrl: './dish-account-import.component.css'
})
export class DishAccountImportComponent {
  dishAccountForm: FormGroup;
  manualSyncLoading = false;
  syncResponse: any | null = null;
  customerLookupMessage: string | null = null;
  customerDetails: Array<{ label: string; value: string }> = [];
  createdCustomerId: string | null = null;
  currentUser: any = null;

  dishInfo: any;
  private hasDishData = false;

  constructor(
    private fb: FormBuilder,
    private dataService: DataserviceService,
    private message: NzMessageService
  ) {
    try {
      this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    } catch (_) {
      this.currentUser = null;
    }
    this.dishAccountForm = this.fb.group({
      accountNumber: ['', Validators.required],
      lastName: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      authenticated: [{ value: 'YES', disabled: true }]
    });
  }

  submitManualSync(): void {
    if (this.dishAccountForm.invalid) {
      this.dishAccountForm.markAllAsTouched();
      return;
    }

    const payload = {
      accountNumber: this.dishAccountForm.get('accountNumber')?.value,
      last: this.dishAccountForm.get('lastName')?.value,
      phone: this.dishAccountForm.get('phoneNumber')?.value,
      authenticated: 'YES',
      user: this.currentUser
    };

    if (!this.currentUser || !this.currentUser?.id) {
      try {
        this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
      } catch (_) {
        this.currentUser = null;
      }
    }

    this.manualSyncLoading = true;
    this.syncResponse = null;
    this.customerLookupMessage = null;
    this.customerDetails = [];
    this.createdCustomerId = null;
    this.hasDishData = false;
    this.syncWithDish(payload);
    // this.checkWODB(payload.accountNumber, payload, true);
  }

  resetForm(): void {
    this.dishAccountForm.reset({
      accountNumber: '',
      lastName: '',
      phoneNumber: '',
      authenticated: 'YES'
    });
    this.syncResponse = null;
    this.customerLookupMessage = null;
    this.customerDetails = [];
    this.createdCustomerId = null;
  }

  private syncWithDish(payload: any) {
    if (!payload) {
      this.manualSyncLoading = false;
      this.message.error('Missing account information for Dish sync');
      this.customerLookupMessage = 'Customer lookup failed.';
      this.customerDetails = [];
      return;
    }

    this.dataService.postData(payload, 'dish/dishImport').subscribe({
      next: (res: any) => {
        console.log('This is the response from dish: ', res);
        if (res?.result === 'success') {
          this.dishInfo = res.data.data;
          this.hasDishData = !!this.dishInfo?.AccountInformation?.AccountNumber;
          // if (this.hasDishData) {
          //   this.checkWODB(this.dishInfo.AccountInformation.AccountNumber);
            this.message.success('Dish account synced successfully');
            this.dishAccountForm.reset();
          // } else {
            this.manualSyncLoading = false;
          //   this.message.warning('Dish sync did not return an account; no records created');
          //   this.customerLookupMessage = 'Customer not found.';
          //   this.customerDetails = [];
          // }
        } else {
          this.syncResponse = null;
          this.hasDishData = false;
          this.manualSyncLoading = false;
          this.message.error(res?.message || 'Failed to sync Dish account');
          this.customerLookupMessage = 'Customer lookup failed.';
          this.customerDetails = [];
        }
      },
      error: () => {
        this.manualSyncLoading = false;
        this.syncResponse = null;
        this.hasDishData = false;
        this.message.error('Failed to sync Dish account');
        this.customerLookupMessage = 'Customer lookup failed.';
        this.customerDetails = [];
      }
    });
  }

  checkWODB(accountNumber: any, payload?: any, triggerDishFallback = false) {
    // check db to see if we have a work order based on the account number. if not then we will create one
    this.dataService.getData(`work-order/dishWo/${accountNumber}`).subscribe({
      next: (r: any) => {
        console.log('This should be work order id: ', r);
        if (r.result === 'success' && Array.isArray(r.data) && r.data.length > 0) {
          const workOrderId = r.data[0]?.id ?? r.data[0];
          this.checkCustomerDB(workOrderId, payload, triggerDishFallback);
        } else if (triggerDishFallback) {
          this.syncWithDish(payload);
        } else if (this.hasDishData) {
          this.createWo(this.dishInfo);
        } else {
          this.manualSyncLoading = false;
          this.message.warning('Work order not found and Dish account data is unavailable');
          this.customerLookupMessage = 'Customer not found.';
          this.customerDetails = [];
        }
      },
      error: () => {
        if (triggerDishFallback) {
          this.syncWithDish(payload);
        } else {
          this.manualSyncLoading = false;
          this.message.error('Failed to check work orders');
          this.customerLookupMessage = 'Customer lookup failed.';
          this.customerDetails = [];
        }
      }
    });
  }

  checkCustomerDB(id: any, payload?: any, triggerDishFallback = false) {
    // check db to see if we have a customer already. if not then we will create one
    console.log('Check customer function: ', id);
    this.dataService.getData(`customers/simple-order-id/${id}`).subscribe({
      next: (r: any) => {
        console.log('This should be the customer information: ', r);
        if (r.result === 'success' && Array.isArray(r.data) && r.data.length > 0) {
          this.syncResponse = r.data[0];
          this.customerLookupMessage = 'Customer found.';
          this.customerDetails = this.buildCustomerDetails(this.syncResponse);
          if (triggerDishFallback) {
            this.manualSyncLoading = false;
            this.message.success('Found existing work order and customer');
          } else {
            this.manualSyncLoading = false;
            this.message.success('Found existing work order and customer');
          }
        } else if (triggerDishFallback) {
          this.syncWithDish(payload);
        } else if (this.hasDishData) {
          this.customerLookupMessage = 'Customer not found. Creating new record from Dish data.';
          this.customerDetails = [];
          this.createCustomer(this.dishInfo);
        } else {
          this.manualSyncLoading = false;
          this.message.warning('Customer not found and Dish account data is unavailable');
          this.customerLookupMessage = 'Customer not found.';
          this.customerDetails = [];
        }
      },
      error: () => {
        if (triggerDishFallback) {
          this.syncWithDish(payload);
        } else {
          this.manualSyncLoading = false;
          this.message.error('Failed to check customer records');
          this.customerLookupMessage = 'Customer lookup failed.';
          this.customerDetails = [];
        }
      }
    });
    // this.createCustomer(this.dishInfo.AccountInformation.CustomerInformation)
  }

  private getDishProviderId(): string | null {
    if (this.currentUser?.providers && Array.isArray(this.currentUser.providers)) {
      const dishProvider = this.currentUser.providers.find((p: any) =>
        (p?.name || '').toLowerCase() === 'dish'
      );
      return dishProvider?.id || dishProvider?.provider_id || null;
    }
    return null;
  }

  createWo(woInfo: any, customerId?: string) {
    const info = woInfo || this.dishInfo;
    if (!info) {
      this.manualSyncLoading = false;
      this.message.error('Missing Dish data for work order');
      this.customerLookupMessage = 'Work order create failed.';
      return;
    }

    const accountInfo = info?.AccountInformation || {};
    const accountNumber = accountInfo?.AccountNumber || '';
    const saleDateImportant = this.getDishImportantDate(info, 'sale');
    const installDateImportant = this.getDishImportantDate(info, 'install');
    const saleDate = info?.sale_date || accountInfo?.SaleDate || saleDateImportant;
    const installDate = info?.install_date || installDateImportant || info?.generic?.installInfo?.date;
    const saleDateIso = this.toIsoDate(saleDate);
    const installDateIso = this.toIsoDate(installDate);

    const genericPayload: any = info?.generic ? { ...info.generic } : this.buildGenericFromDish(info);
    genericPayload.manualSyncMeta = {
      accountNumber: accountNumber || '',
      saleDate: saleDateIso || saleDate || '',
      installDate: installDateIso || installDate || '',
      sync: true
    };

    const finalCustomerId =
      customerId ||
      this.createdCustomerId ||
      this.syncResponse?.id ||
      this.syncResponse?.customer_id;

    if (!finalCustomerId) {
      if (!this.customerLookupMessage) {
        this.customerLookupMessage = 'Creating new customer from Dish data.';
      }
      this.customerDetails = [];
      this.createCustomer(info);
      return;
    }

    const payload: any = {
      status: info?.status || accountInfo?.AccountStatus || 'pending',
      customer_id: finalCustomerId,
      provider: 'dish',
      provider_id: this.getDishProviderId(),
      company_id: this.currentUser?.company_id,
      distributor_id: this.currentUser?.distributor_id,
      order_id: accountNumber || '',
      sale_date: saleDateIso,
      install_date: installDateIso,
      generic: genericPayload
    };

    if (this.currentUser?.id) {
      payload.user_id = this.currentUser.id;
    }
    if (this.currentUser?.company_id) {
      payload.company_id = this.currentUser.company_id;
    }
    if (this.currentUser?.distributor_id) {
      payload.distributor_id = this.currentUser.distributor_id;
    }
    if (!payload.sale_date) {
      delete payload.sale_date;
    }
    if (!payload.install_date) {
      delete payload.install_date;
    }

    console.log('Creating work order payload', payload);
    this.dataService.postDataNoBodyDotBody(payload, 'work-order/create').subscribe({
      next: (res: any) => {
        if (res?.result === 'success') {
          this.manualSyncLoading = false;
          if (this.customerLookupMessage) {
            this.customerLookupMessage = this.customerLookupMessage + ' Work order created.';
          } else {
            this.customerLookupMessage = 'Work order created.';
          }
          this.message.success('Created Dish work order');
          if (this.syncResponse) {
            this.syncResponse = {
              ...this.syncResponse,
              order_id: accountNumber || this.syncResponse.order_id,
              sale_date: saleDateIso || this.syncResponse.sale_date,
              install_date: installDateIso || this.syncResponse.install_date,
              status: payload.status || this.syncResponse.status
            };
            this.customerDetails = this.buildCustomerDetails(this.syncResponse);
          }
        } else {
          this.manualSyncLoading = false;
          this.customerLookupMessage = 'Work order create failed.';
          this.message.error('Failed to create work order');
        }
      },
      error: () => {
        this.manualSyncLoading = false;
        this.customerLookupMessage = 'Work order create failed.';
        this.message.error('Failed to create work order');
      }
    });
  }

  createCustomer(dishInfo: any) {
    if (this.createdCustomerId) {
      this.createWo(this.dishInfo, this.createdCustomerId);
      return;
    }

    const info = dishInfo || this.dishInfo;
    if (!info) {
      this.manualSyncLoading = false;
      this.customerLookupMessage = 'Customer creation failed.';
      this.message.error('Missing Dish data for customer create');
      return;
    }

    const accountInfo = info?.AccountInformation || {};
    const customerInfo = accountInfo?.CustomerInformation || info?.CustomerInformation || {};
    const serviceInfo = customerInfo?.ServiceInformation || {};
    const billingInfo = customerInfo?.BillingInformation || {};
    const generalName = customerInfo?.CustomerName || {};
    const serviceName = serviceInfo?.Name || {};
    const billingName = billingInfo?.Name || {};
    const serviceAddress = serviceInfo?.Address || {};
    const billingAddress = billingInfo?.Address || {};
    const accountAddress = accountInfo?.ServiceAddress?.Address || {};
    let addressSource: any = serviceAddress;
    if (!addressSource?.LineOne) {
      addressSource = accountAddress;
    }
    if (!addressSource?.LineOne) {
      addressSource = billingAddress;
    }
    const formValues = this.dishAccountForm.getRawValue();

    let firstName = customerInfo?.FirstName || '';
    if (!firstName && generalName?.FirstName) {
      firstName = generalName.FirstName;
    }
    if (!firstName && serviceName?.FirstName) {
      firstName = serviceName.FirstName;
    }
    if (!firstName && billingName?.FirstName) {
      firstName = billingName.FirstName;
    }
    if (!firstName) {
      firstName = formValues?.lastName || '';
    }

    let lastName = customerInfo?.LastName || '';
    if (!lastName && generalName?.LastName) {
      lastName = generalName.LastName;
    }
    if (!lastName && serviceName?.LastName) {
      lastName = serviceName.LastName;
    }
    if (!lastName && billingName?.LastName) {
      lastName = billingName.LastName;
    }
    if (!lastName) {
      lastName = formValues?.lastName || '';
    }

    let phoneNumber = '';
    if (Array.isArray(customerInfo?.PhoneNumbers) && customerInfo.PhoneNumbers.length > 0) {
      phoneNumber = customerInfo.PhoneNumbers[0]?.Number || '';
    }
    if (!phoneNumber && Array.isArray(accountInfo?.PhoneNumbers) && accountInfo.PhoneNumbers.length > 0) {
      phoneNumber = accountInfo.PhoneNumbers[0]?.Number || '';
    }
    if (!phoneNumber && customerInfo?.PrimaryPhone) {
      phoneNumber = customerInfo.PrimaryPhone;
    }
    if (!phoneNumber && customerInfo?.PhoneNumber) {
      phoneNumber = customerInfo.PhoneNumber;
    }
    if (!phoneNumber && formValues?.phoneNumber) {
      phoneNumber = formValues.phoneNumber;
    }
    if (phoneNumber) {
      phoneNumber = String(phoneNumber).trim();
      if (phoneNumber) {
        phoneNumber = phoneNumber.replace(/\D/g, '');
      }
    }

    let emailAddress = customerInfo?.EmailAddress || '';
    if (!emailAddress && billingInfo?.EmailAddress) {
      emailAddress = billingInfo.EmailAddress;
    }
    if (!emailAddress && serviceInfo?.EmailAddress) {
      emailAddress = serviceInfo.EmailAddress;
    }
    if (!emailAddress && customerInfo?.Email) {
      emailAddress = customerInfo.Email;
    }

    const saleDate = info?.sale_date || this.getDishImportantDate(info, 'sale');
    const installDate =
      info?.install_date ||
      this.getDishImportantDate(info, 'install') ||
      info?.generic?.installInfo?.date;
    const accountNumber = accountInfo?.AccountNumber || '';

    const payload: any = {
      first_name: firstName ? firstName.trim() : 'Unknown',
      last_name: lastName ? lastName.trim() : (formValues?.lastName || ''),
      phone_number: phoneNumber || '',
      email: emailAddress ? emailAddress.trim() : '',
      address_line_1: addressSource?.LineOne ? String(addressSource.LineOne).trim() : '',
      address_line_2: addressSource?.LineTwo ? String(addressSource.LineTwo).trim() : '',
      address_city: addressSource?.City ? String(addressSource.City).trim() : '',
      address_state: addressSource?.State ? String(addressSource.State).trim() : '',
      address_zip: addressSource?.Zip ? String(addressSource.Zip).trim() : '',
      date_of_birth: customerInfo?.DateOfBirth || customerInfo?.DOB || '',
      status: info?.status || accountInfo?.AccountStatus || '',
      sale_date: this.toIsoDate(saleDate),
      install_date: this.toIsoDate(installDate),
      order_id: accountNumber || '',
      origination: 'dish-flow'
    };

    if (info?.crm_id) {
      payload.crm_id = info.crm_id;
    }
    if (this.currentUser?.id) {
      payload.user_id = this.currentUser.id;
    }
    if (this.currentUser?.user_crm_id) {
      payload.user_crm_id = this.currentUser.user_crm_id;
    }
    if (this.currentUser?.company_id) {
      payload.company_id = this.currentUser.company_id;
    }
    if (this.currentUser?.distributor_id) {
      payload.distributor_id = this.currentUser.distributor_id;
    }
    if (!payload.sale_date) {
      delete payload.sale_date;
    }
    if (!payload.install_date) {
      delete payload.install_date;
    }

    if (!payload.first_name) {
      payload.first_name = 'Unknown';
    }
    if (!payload.phone_number) {
      payload.phone_number = formValues?.phoneNumber || '';
    }
    if (payload.phone_number && typeof payload.phone_number !== 'string') {
      payload.phone_number = String(payload.phone_number);
    }

    console.log('Creating customer payload', payload);
    this.dataService.postDataNoBodyDotBody(payload, 'customers/create').subscribe({
      next: (res: any) => {
        if (res?.result === 'success') {
          const newId = res?.data?.id || res?.data;
          if (newId) {
            this.createdCustomerId = newId;
            this.syncResponse = { ...payload, id: newId };
            this.customerDetails = this.buildCustomerDetails(this.syncResponse);
            this.customerLookupMessage = 'Customer created from Dish data.';
            this.message.success('Created customer from Dish data');
            this.createWo(info, newId);
            return;
          }
        }
        this.manualSyncLoading = false;
        this.customerLookupMessage = 'Customer creation failed.';
        this.customerDetails = [];
        this.syncResponse = null;
        this.message.error('Failed to create customer');
      },
      error: () => {
        this.manualSyncLoading = false;
        this.customerLookupMessage = 'Customer creation failed.';
        this.customerDetails = [];
        this.syncResponse = null;
        this.message.error('Failed to create customer');
      }
    });
  }

  private buildCustomerDetails(customer: any): Array<{ label: string; value: string }> {
    if (!customer) {
      return [];
    }

    const details: Array<{ label: string; value: string }> = [];
    const pushDetail = (label: string, value: any) => {
      if (value === undefined || value === null || value === '') {
        return;
      }
      details.push({ label, value: String(value) });
    };

    pushDetail('Customer ID', customer.id ?? customer.customer_id);
    pushDetail('First Name', customer.first_name);
    pushDetail('Last Name', customer.last_name);
    pushDetail('Status', customer.status ?? customer.sales_status ?? customer.provider_status);
    pushDetail('Sale Date', customer.sale_date);
    pushDetail('Install Date', customer.install_date);
    pushDetail('Order ID', customer.order_id ?? customer.orderId);
    pushDetail('Phone Number', customer.phone_number ?? customer.phone);
    pushDetail('Secondary Phone', customer.secondary_phone_number);
    pushDetail('Email', customer.email);
    const addressLine = [customer.address_line_1, customer.address_line_2].filter(Boolean).join(', ');
    pushDetail('Address', addressLine || customer.address);
    const cityStateZip = [
      customer.address_city,
      customer.address_state,
      customer.address_zip ?? customer.zipcode
    ].filter(Boolean).join(', ');
    pushDetail('City/State/Zip', cityStateZip);

    return details;
  }

  private toIsoDate(value: any): string | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return value.toISOString();
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) {
        return null;
      }

      const dashParts = trimmed.split('-');
      if (dashParts.length === 3) {
        const [first, second, third] = dashParts;
        // handle dd-mm-yyyy
        if (first.length === 2 && third.length === 4) {
          const day = parseInt(first, 10);
          const month = parseInt(second, 10);
          const year = parseInt(third, 10);
          if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
            const dt = new Date(Date.UTC(year, month - 1, day));
            if (!isNaN(dt.getTime())) {
              return dt.toISOString();
            }
          }
        }
      }

      const parsed = new Date(trimmed);
      if (!isNaN(parsed.getTime())) {
        return parsed.toISOString();
      }
    }

    return null;
  }

  private getDishImportantDate(dishInfo: any, keyword: string): string {
    if (!dishInfo) {
      return '';
    }
    const accountInfo = dishInfo?.AccountInformation;
    const categories = accountInfo?.ImportantDates?.DateCategory;
    if (!Array.isArray(categories)) {
      return '';
    }

    let matchDate = '';
    for (const cat of categories) {
      const name = (cat?.CategoryName || '').toString().toLowerCase();
      if (name.includes(keyword.toLowerCase())) {
        const dateObj = cat?.Date;
        const year = dateObj?.Year;
        const month = dateObj?.Month;
        const day = dateObj?.Day;
        if (year && month && day) {
          const monthStr = month.toString().padStart(2, '0');
          const dayStr = day.toString().padStart(2, '0');
          matchDate = `${year}-${monthStr}-${dayStr}`;
          break;
        }
      }
    }
    return matchDate;
  }

  private buildGenericFromDish(info: any) {
    const generic: any = {};
    const accountInfo = info?.AccountInformation || {};
    const scrub =
      info?.scrubAddressResponse ||
      info?.generic?.scrubAddressResponse ||
      accountInfo?.scrubAddressResponse;
    if (scrub) {
      generic.scrubAddressResponse = scrub;
    }

    const auth =
      info?.authenticateCustomerResponse?.AuthenticateCustomerResponse ||
      info?.authenticateCustomerResponse ||
      accountInfo?.CustomerInformation;
    if (auth) {
      generic.authenticateCustomerResponse = auth;
    }

    if (info?.conversationId) {
      generic.conversationId = info.conversationId;
    }

    if (info?.validateProgrammingResponse) {
      generic.validateProgrammingResponse = info.validateProgrammingResponse;
    }

    if (info?.selectedChannels) {
      generic.selectedChannels = info.selectedChannels;
    }

    if (info?.selectedEquipment) {
      generic.selectedEquipment = info.selectedEquipment;
    }

    if (info?.installInfo) {
      generic.installInfo = info.installInfo;
    } else if (info?.generic?.installInfo) {
      generic.installInfo = info.generic.installInfo;
    }

    if (info?.processingFeeInfo) {
      generic.processingFeeInfo = info.processingFeeInfo;
    }

    if (info?.basisTheoryCards) {
      generic.basisTheoryCards = info.basisTheoryCards;
    }

    return generic;
  }
}
